export class Phrases {
  static readonly tcaNewIdNeededTitle = "New FitLinxx ID Needed";
  static readonly tcaNewIdNeededMessage = "This member no longer has a valid FitLinxx ID";
  static readonly tcaNewIdNeededYes = "Press YES to change status and assign a new FitLinxx ID.";
  static readonly tcaNewIdNeededNo = "Press NO to keep status Terminated.";
}
